// tslint:disable
/**
 * API Studenter API
 * ALP api for Studenter
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import { COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface BrukerinfoAdresseDto
 */
export interface BrukerinfoAdresseDto {
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoAdresseDto
     */
    'gateadresse'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoAdresseDto
     */
    'postnr'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoAdresseDto
     */
    'poststed'?: string;
}
/**
 * 
 * @export
 * @interface BrukerinfoDto
 */
export interface BrukerinfoDto {
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoDto
     */
    'epost': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoDto
     */
    'telefonnummer': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoDto
     */
    'studentnr': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerinfoDto
     */
    'kjonn': BrukerinfoDtoKjonnDtoEnum;
    /**
     * 
     * @type {number}
     * @memberof BrukerinfoDto
     */
    'alder': number;
    /**
     * 
     * @type {BrukerinfoAdresseDto}
     * @memberof BrukerinfoDto
     */
    'adresse': BrukerinfoAdresseDto;
    /**
     * 
     * @type {BrukerinnstillingerDto}
     * @memberof BrukerinfoDto
     */
    'innstillinger': BrukerinnstillingerDto;
}

export const BrukerinfoDtoKjonnDtoEnum = {
    Mann: 'Mann',
    Kvinne: 'Kvinne'
} as const;

export type BrukerinfoDtoKjonnDtoEnum = typeof BrukerinfoDtoKjonnDtoEnum[keyof typeof BrukerinfoDtoKjonnDtoEnum];

/**
 * 
 * @export
 * @interface BrukerinnstillingerDto
 */
export interface BrukerinnstillingerDto {
    /**
     * 
     * @type {string}
     * @memberof BrukerinnstillingerDto
     */
    'spraakvalg'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrukerinnstillingerDto
     */
    'forstaatHvorProfildataKommerFra'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrukerinnstillingerDto
     */
    'harGodtattBetingelser'?: boolean;
}
/**
 * 
 * @export
 * @interface EmneDto
 */
export interface EmneDto {
    /**
     * 
     * @type {string}
     * @memberof EmneDto
     */
    'kode': string;
    /**
     * 
     * @type {string}
     * @memberof EmneDto
     */
    'navn': string;
}
/**
 * 
 * @export
 * @interface FagpersonDto
 */
export interface FagpersonDto {
    /**
     * 
     * @type {string}
     * @memberof FagpersonDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FagpersonDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof FagpersonDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof FagpersonDto
     */
    'rolle': FagpersonDtoRolleDtoEnum;
    /**
     * 
     * @type {string}
     * @memberof FagpersonDto
     */
    'epost'?: string;
    /**
     * 
     * @type {string}
     * @memberof FagpersonDto
     */
    'telefonnummer'?: string;
}

export const FagpersonDtoRolleDtoEnum = {
    StudiestedKoordinator: 'StudiestedKoordinator',
    StudiestedUnderviser: 'StudiestedUnderviser',
    PraksisstedKoordinator: 'PraksisstedKoordinator',
    PraksisstedVeileder: 'PraksisstedVeileder'
} as const;

export type FagpersonDtoRolleDtoEnum = typeof FagpersonDtoRolleDtoEnum[keyof typeof FagpersonDtoRolleDtoEnum];

/**
 * 
 * @export
 * @interface MinimalPraksisstedDto
 */
export interface MinimalPraksisstedDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedDto
     */
    'navn': string;
}
/**
 * 
 * @export
 * @interface PraksisaktivitetDto
 */
export interface PraksisaktivitetDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetDto
     */
    'id': string;
    /**
     * 
     * @type {EmneDto}
     * @memberof PraksisaktivitetDto
     */
    'emne': EmneDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetDto
     */
    'startDato': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetDto
     */
    'sluttDato': string;
    /**
     * 
     * @type {PraksisaktivitetStatuserDto}
     * @memberof PraksisaktivitetDto
     */
    'status'?: PraksisaktivitetStatuserDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetDto
     */
    'onskelisteFrist'?: string;
    /**
     * 
     * @type {number}
     * @memberof PraksisaktivitetDto
     */
    'maxAntallOnsker': number;
    /**
     * 
     * @type {Array<PraksisplassOnskeDto>}
     * @memberof PraksisaktivitetDto
     */
    'onskeliste': Array<PraksisplassOnskeDto>;
    /**
     * 
     * @type {PraksisstedprofilDto}
     * @memberof PraksisaktivitetDto
     */
    'praksisstedprofil'?: PraksisstedprofilDto;
    /**
     * 
     * @type {Array<FagpersonDto>}
     * @memberof PraksisaktivitetDto
     */
    'fagpersoner': Array<FagpersonDto>;
    /**
     * 
     * @type {Array<StudentDto>}
     * @memberof PraksisaktivitetDto
     */
    'medstudenter': Array<StudentDto>;
    /**
     * 
     * @type {string}
     * @memberof PraksisaktivitetDto
     */
    'fritekst'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PraksisaktivitetStatuserDto = {
    Undervisningsmeldt: 'Undervisningsmeldt',
    Registrert: 'Registrert',
    OnskelisteTilgjengelig: 'OnskelisteTilgjengelig',
    OnskelisteRegistrert: 'OnskelisteRegistrert',
    OnskelisteRegistrertIkkeTilgjengelig: 'OnskelisteRegistrertIkkeTilgjengelig',
    AvventerFordeling: 'AvventerFordeling',
    IkkePublisert: 'IkkePublisert',
    PraksisplassMottatt: 'PraksisplassMottatt',
    Aktiv: 'Aktiv',
    Gjennomfoert: 'Gjennomfoert'
} as const;

export type PraksisaktivitetStatuserDto = typeof PraksisaktivitetStatuserDto[keyof typeof PraksisaktivitetStatuserDto];


/**
 * 
 * @export
 * @interface PraksisoversiktDto
 */
export interface PraksisoversiktDto {
    /**
     * 
     * @type {Array<PraksisoversiktEmneDto>}
     * @memberof PraksisoversiktDto
     */
    'emner': Array<PraksisoversiktEmneDto>;
}
/**
 * 
 * @export
 * @interface PraksisoversiktEmneDto
 */
export interface PraksisoversiktEmneDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisoversiktEmneDto
     */
    'emne': string;
    /**
     * 
     * @type {PraksisaktivitetStatuserDto}
     * @memberof PraksisoversiktEmneDto
     */
    'status': PraksisaktivitetStatuserDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisoversiktEmneDto
     */
    'startDato': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisoversiktEmneDto
     */
    'sluttDato': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisoversiktEmneDto
     */
    'praksissaktivitet'?: string;
}


/**
 * 
 * @export
 * @interface PraksisplassOnskeDto
 */
export interface PraksisplassOnskeDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisplassOnskeDto
     */
    'id'?: string;
    /**
     * 
     * @type {MinimalPraksisstedDto}
     * @memberof PraksisplassOnskeDto
     */
    'praksissted': MinimalPraksisstedDto;
    /**
     * 
     * @type {MinimalPraksisstedDto}
     * @memberof PraksisplassOnskeDto
     */
    'praksisplass': MinimalPraksisstedDto;
}
/**
 * 
 * @export
 * @interface PraksisstedAvdelingDto
 */
export interface PraksisstedAvdelingDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedAvdelingDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedAvdelingDto
     */
    'navn'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PraksisstedAvdelingDto
     */
    'bildeUrler'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedAvdelingDto
     */
    'beskrivelse'?: string;
    /**
     * 
     * @type {MinimalPraksisstedDto}
     * @memberof PraksisstedAvdelingDto
     */
    'praksisstedTopp'?: MinimalPraksisstedDto;
}
/**
 * 
 * @export
 * @interface PraksisstedprofilAdresseDto
 */
export interface PraksisstedprofilAdresseDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilAdresseDto
     */
    'adresselinje1'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilAdresseDto
     */
    'adresselinje2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilAdresseDto
     */
    'postnr'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilAdresseDto
     */
    'poststed'?: string;
}
/**
 * 
 * @export
 * @interface PraksisstedprofilDto
 */
export interface PraksisstedprofilDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'navn': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'orgnr'?: string;
    /**
     * 
     * @type {MinimalPraksisstedDto}
     * @memberof PraksisstedprofilDto
     */
    'avdeling'?: MinimalPraksisstedDto;
    /**
     * 
     * @type {PraksisstedprofilAdresseDto}
     * @memberof PraksisstedprofilDto
     */
    'adresse'?: PraksisstedprofilAdresseDto;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'nettsideUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'epost'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'telefonnummer'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'bildeUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'beskrivelse'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedprofilDto
     */
    'krav'?: string;
    /**
     * 
     * @type {PraksisstedprofilNoderDto}
     * @memberof PraksisstedprofilDto
     */
    'noder'?: PraksisstedprofilNoderDto;
}
/**
 * 
 * @export
 * @interface PraksisstedprofilNoderDto
 */
export interface PraksisstedprofilNoderDto {
    /**
     * 
     * @type {Array<MinimalPraksisstedDto>}
     * @memberof PraksisstedprofilNoderDto
     */
    'over': Array<MinimalPraksisstedDto>;
}
/**
 * 
 * @export
 * @interface StudentDto
 */
export interface StudentDto {
    /**
     * 
     * @type {string}
     * @memberof StudentDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StudentDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof StudentDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof StudentDto
     */
    'epost'?: string;
}

        /**
        * BrukerApi - object-oriented interface
        * @export
        * @class BrukerApiInterface
        * @extends {BaseAPI}
        */
        export interface BrukerApiInterface {
            /**
            * 
                * @summary hent informasjon om bruker
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            brukerinfoGet(params?: { 
            options?: any
            }): Promise<BrukerinfoDto>;
            /**
            * 
                * @summary endre innstillinger
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            brukerinfoInnstillingerPut(params: { 
                brukerinnstillingerDto: BrukerinnstillingerDto,
            options?: any
            }): Promise<void>;
            }
        /**
        * BrukerApi - object-oriented interface
        * @export
        * @class BrukerApi
        * @extends {BaseAPI}
        */
            export class BrukerApi extends BaseAPI implements BrukerApiInterface {
            /**
            * 
                * @summary hent informasjon om bruker
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async brukerinfoGet(params?: { 
            options?: any
            }): Promise<BrukerinfoDto> {
            return await this.GET(
        "/brukerinfo",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary endre innstillinger
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async brukerinfoInnstillingerPut(params: { 
            brukerinnstillingerDto: BrukerinnstillingerDto,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        "/brukerinfo/innstillinger",
        {},
        { body: params.brukerinnstillingerDto, contentType: "application/json" },
            params && params.options,
            );
            }
        }
            export function mockBrukerApi(operations: {
            brukerinfoGet?: (params?: { 
                options?: any
                }) => Promise<BrukerinfoDto>
            brukerinfoInnstillingerPut?: (params: { 
                brukerinnstillingerDto: BrukerinnstillingerDto,
                options?: any
                }) => Promise<void>
            }): BrukerApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            brukerinfoGet: (operations.brukerinfoGet || reject("brukerinfoGet")),
            brukerinfoInnstillingerPut: (operations.brukerinfoInnstillingerPut || reject("brukerinfoInnstillingerPut")),
            };
            }


        /**
        * PraksisApi - object-oriented interface
        * @export
        * @class PraksisApiInterface
        * @extends {BaseAPI}
        */
        export interface PraksisApiInterface {
            /**
            * 
                * @summary Liste over undervisningsmeldinger eller aktivteter i angitt periode
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisApi
            */
            praksisGet(params: { 
                queryParams?: { fromDate: number,  },
            options?: any
            }): Promise<PraksisoversiktDto>;
            /**
            * 
                * @summary Henter praksisaktiviteten med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisApi
            */
            praksisaktivitetIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisaktivitetDto>;
            /**
            * 
                * @summary Fjerner en praksisplass fra ønskelisten for students praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisApi
            */
            praksisaktivitetIdOnskeOnskeIdDelete(params: { 
                pathParams: { id: string, onskeId: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Endrer prioritering på ønskelisten for studentens praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisApi
            */
            praksisaktivitetIdOnskeOnskeIdPut(params: { 
                pathParams: { id: string, onskeId: string,  },
                body: number,
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Legger til en ønsket praksisplass på ønskelisten for studentens praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisApi
            */
            praksisaktivitetIdOnskePost(params: { 
                pathParams: { id: string,  },
                body: string,
            options?: any
            }): Promise<string>;
            }
        /**
        * PraksisApi - object-oriented interface
        * @export
        * @class PraksisApi
        * @extends {BaseAPI}
        */
            export class PraksisApi extends BaseAPI implements PraksisApiInterface {
            /**
            * 
                * @summary Liste over undervisningsmeldinger eller aktivteter i angitt periode
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisApi
            */
            public async praksisGet(params: { 
                queryParams?: { fromDate: number,  },
            options?: any
            }): Promise<PraksisoversiktDto> {
            return await this.GET(
        "/praksis",
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter praksisaktiviteten med gitt id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisApi
            */
            public async praksisaktivitetIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisaktivitetDto> {
            return await this.GET(
        this.path("/praksisaktivitet/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Fjerner en praksisplass fra ønskelisten for students praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisApi
            */
            public async praksisaktivitetIdOnskeOnskeIdDelete(params: { 
                pathParams: { id: string, onskeId: string,  },
            options?: any
            }): Promise<void> {
            return await this.DELETE(
        this.path("/praksisaktivitet/{id}/onske/{onskeId}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Endrer prioritering på ønskelisten for studentens praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisApi
            */
            public async praksisaktivitetIdOnskeOnskeIdPut(params: { 
                pathParams: { id: string, onskeId: string,  },
            body: number,
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/praksisaktivitet/{id}/onske/{onskeId}", params.pathParams),
        {},
        { body: params.body, contentType: "application/json" },
            params && params.options,
            );
            }
            /**
            * 
                * @summary Legger til en ønsket praksisplass på ønskelisten for studentens praksisaktivitet
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisApi
            */
            public async praksisaktivitetIdOnskePost(params: { 
                pathParams: { id: string,  },
            body: string,
            options?: any
            }): Promise<string> {
            return await this.POST(
        this.path("/praksisaktivitet/{id}/onske", params.pathParams),
        {},
        { body: params.body, contentType: "application/json" },
            params && params.options,
            );
            }
        }
            export function mockPraksisApi(operations: {
            praksisGet?: (params: { 
                    queryParams?: { fromDate: number,  },
                options?: any
                }) => Promise<PraksisoversiktDto>
            praksisaktivitetIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<PraksisaktivitetDto>
            praksisaktivitetIdOnskeOnskeIdDelete?: (params: { 
                    pathParams: { id: string, onskeId: string,  },
                options?: any
                }) => Promise<void>
            praksisaktivitetIdOnskeOnskeIdPut?: (params: { 
                    pathParams: { id: string, onskeId: string,  },
                body: number,
                options?: any
                }) => Promise<void>
            praksisaktivitetIdOnskePost?: (params: { 
                    pathParams: { id: string,  },
                body: string,
                options?: any
                }) => Promise<string>
            }): PraksisApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            praksisGet: (operations.praksisGet || reject("praksisGet")),
            praksisaktivitetIdGet: (operations.praksisaktivitetIdGet || reject("praksisaktivitetIdGet")),
            praksisaktivitetIdOnskeOnskeIdDelete: (operations.praksisaktivitetIdOnskeOnskeIdDelete || reject("praksisaktivitetIdOnskeOnskeIdDelete")),
            praksisaktivitetIdOnskeOnskeIdPut: (operations.praksisaktivitetIdOnskeOnskeIdPut || reject("praksisaktivitetIdOnskeOnskeIdPut")),
            praksisaktivitetIdOnskePost: (operations.praksisaktivitetIdOnskePost || reject("praksisaktivitetIdOnskePost")),
            };
            }


        /**
        * PraksisstedApi - object-oriented interface
        * @export
        * @class PraksisstedApiInterface
        * @extends {BaseAPI}
        */
        export interface PraksisstedApiInterface {
            /**
            * 
                * @summary Hent et bilde basert på praksissted og bilde-id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedBildePraksisstedIdBildeIdGet(params: { 
                pathParams: { praksisstedId: string, bildeId: string,  },
            options?: any
            }): Promise<File>;
            /**
            * 
                * @summary Henter informasjon om praksissteder som innlogget student kan ønske seg
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstederForOnskelistePraksisaktivitetIdGet(params: { 
                pathParams: { praksisaktivitetId: string,  },
            options?: any
            }): Promise<Array<PraksisstedAvdelingDto>>;
            /**
            * 
                * @summary Hent en praksisstedprofil, basert på praksissted-nodens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedprofilIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisstedprofilDto>;
            }
        /**
        * PraksisstedApi - object-oriented interface
        * @export
        * @class PraksisstedApi
        * @extends {BaseAPI}
        */
            export class PraksisstedApi extends BaseAPI implements PraksisstedApiInterface {
            /**
            * 
                * @summary Hent et bilde basert på praksissted og bilde-id
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedBildePraksisstedIdBildeIdGet(params: { 
                pathParams: { praksisstedId: string, bildeId: string,  },
            options?: any
            }): Promise<File> {
            return await this.GET(
        this.path("/praksisstedBilde/{praksisstedId}/{bildeId}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter informasjon om praksissteder som innlogget student kan ønske seg
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstederForOnskelistePraksisaktivitetIdGet(params: { 
                pathParams: { praksisaktivitetId: string,  },
            options?: any
            }): Promise<Array<PraksisstedAvdelingDto>> {
            return await this.GET(
        this.path("/praksisstederForOnskeliste/{praksisaktivitetId}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Hent en praksisstedprofil, basert på praksissted-nodens ID
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedprofilIdGet(params: { 
                pathParams: { id: string,  },
            options?: any
            }): Promise<PraksisstedprofilDto> {
            return await this.GET(
        this.path("/praksisstedprofil/{id}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
        }
            export function mockPraksisstedApi(operations: {
            praksisstedBildePraksisstedIdBildeIdGet?: (params: { 
                    pathParams: { praksisstedId: string, bildeId: string,  },
                options?: any
                }) => Promise<File>
            praksisstederForOnskelistePraksisaktivitetIdGet?: (params: { 
                    pathParams: { praksisaktivitetId: string,  },
                options?: any
                }) => Promise<Array<PraksisstedAvdelingDto>>
            praksisstedprofilIdGet?: (params: { 
                    pathParams: { id: string,  },
                options?: any
                }) => Promise<PraksisstedprofilDto>
            }): PraksisstedApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            praksisstedBildePraksisstedIdBildeIdGet: (operations.praksisstedBildePraksisstedIdBildeIdGet || reject("praksisstedBildePraksisstedIdBildeIdGet")),
            praksisstederForOnskelistePraksisaktivitetIdGet: (operations.praksisstederForOnskelistePraksisaktivitetIdGet || reject("praksisstederForOnskelistePraksisaktivitetIdGet")),
            praksisstedprofilIdGet: (operations.praksisstedprofilIdGet || reject("praksisstedprofilIdGet")),
            };
            }



export class Random {
    seed: number;
    constructor(seed: number) {
        this.seed = seed % 2147483647;
        if (this.seed <= 0) this.seed += 2147483646;
    }
    next(): number {
        this.seed = this.seed * 16807 % 2147483647;
        return this.seed;
    }
    nextFloat(): number {
        return (this.next() - 1) / 2147483646;
    }
    nextInt(limit: number): number {
        return this.next() % limit;
    }
    pickOne<T>(options: Array<T>): T {
        return options[this.nextInt(options.length)];
    }
    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            var r = this.nextInt(16) | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    nextBoolean() {
        return this.nextInt(2) == 0;
    }
}

type Factory<T> = {
    [P in keyof T]?: ((sampleData: TestSampleData) => T[P])|T[P];
};
type EnumFactory<T> = ((sampleData: TestSampleData) => T)|T;
export interface SampleModelFactories {
    BrukerinfoAdresseDto?: Factory<BrukerinfoAdresseDto> | ((testData: TestSampleData) => BrukerinfoAdresseDto);
    BrukerinfoDto?: Factory<BrukerinfoDto> | ((testData: TestSampleData) => BrukerinfoDto);
    BrukerinnstillingerDto?: Factory<BrukerinnstillingerDto> | ((testData: TestSampleData) => BrukerinnstillingerDto);
    EmneDto?: Factory<EmneDto> | ((testData: TestSampleData) => EmneDto);
    FagpersonDto?: Factory<FagpersonDto> | ((testData: TestSampleData) => FagpersonDto);
    MinimalPraksisstedDto?: Factory<MinimalPraksisstedDto> | ((testData: TestSampleData) => MinimalPraksisstedDto);
    PraksisaktivitetDto?: Factory<PraksisaktivitetDto> | ((testData: TestSampleData) => PraksisaktivitetDto);
    PraksisaktivitetStatuserDto?: Factory<PraksisaktivitetStatuserDto> | ((testData: TestSampleData) => PraksisaktivitetStatuserDto);
    PraksisoversiktDto?: Factory<PraksisoversiktDto> | ((testData: TestSampleData) => PraksisoversiktDto);
    PraksisoversiktEmneDto?: Factory<PraksisoversiktEmneDto> | ((testData: TestSampleData) => PraksisoversiktEmneDto);
    PraksisplassOnskeDto?: Factory<PraksisplassOnskeDto> | ((testData: TestSampleData) => PraksisplassOnskeDto);
    PraksisstedAvdelingDto?: Factory<PraksisstedAvdelingDto> | ((testData: TestSampleData) => PraksisstedAvdelingDto);
    PraksisstedprofilAdresseDto?: Factory<PraksisstedprofilAdresseDto> | ((testData: TestSampleData) => PraksisstedprofilAdresseDto);
    PraksisstedprofilDto?: Factory<PraksisstedprofilDto> | ((testData: TestSampleData) => PraksisstedprofilDto);
    PraksisstedprofilNoderDto?: Factory<PraksisstedprofilNoderDto> | ((testData: TestSampleData) => PraksisstedprofilNoderDto);
    StudentDto?: Factory<StudentDto> | ((testData: TestSampleData) => StudentDto);
}
export interface SamplePropertyValues {
    [key: string]: (sampleData: TestSampleData) => any;
}

export interface RandomGenerator {
    nextFloat: () => number;
    nextInt: (limit: number) => number;
    nextBoolean: () => boolean;
    pickOne: <T>(options: Array<T>) => T;
    uuidv4: ()  => string;
    randomEmail: () => string;
    randomPastDateTime: (now: Date) => Date;
    generate: (modelClass: string, modelVar: string, dataType: string, example?: string, isNullable?: boolean) => any;
}

export interface TestData {
    seed?: number;
    sampleModelProperties?: SampleModelFactories;
    samplePropertyValues?: SamplePropertyValues;
}
export class TestSampleData implements RandomGenerator {
    random: Random;
    sampleModelProperties: any;
    samplePropertyValues: SamplePropertyValues;
    constructor(testData: TestData) {
        this.random = new Random(testData.seed || 100);
        this.sampleModelProperties = testData.sampleModelProperties || {};
        this.samplePropertyValues = testData.samplePropertyValues || {};
    }
    nextFloat() { return this.random.nextFloat(); }
    nextInt(limit: number) { return this.random.nextInt(limit); }
    nextBoolean() { return this.random.nextBoolean(); }
    pickOne<T>(options: Array<T>) { return this.random.pickOne(options); }
    uuidv4() { return this.random.uuidv4(); }
    randomEmail() {
        return this.pickOne(["james", "mary", "john", "patricia", "robert", "jennifer", "michael", "linda"]) +
            "." + this.pickOne(["smith", "williams", "johnson", "jones", "brown", "davis", "miller", "wilson"]) +
            "@" + this.pickOne(["a", "b", "c", "d", "e"]) + ".example." + this.pickOne(["net", "com", "org"]);
    }
    randomPastDateTime(now: Date) {
        return new Date((now.getTime() - this.nextInt(4*7*24*60*60*1000)));
    }
    generate(modelClass: string, modelVar: string, dataType: string, example?: string, isNullable?: boolean): any {
        if (this.sampleModelProperties[modelClass]) {
            const propertyFactory: Factory<any> = this.sampleModelProperties[modelClass][modelVar];
            if (propertyFactory && typeof propertyFactory === "function") {
                return propertyFactory(this);
            } else if (propertyFactory) {
                return propertyFactory;
            }
        }
        if (this.samplePropertyValues[modelVar]) {
            return this.samplePropertyValues[modelVar](this);
        }
        if (example && example !== "null") return example;
        if (dataType === "Array<string>") {
            return Array.from({length: this.arrayLength("Array<string>")}).map((i) => "foo " + i);
        }
        if (dataType.startsWith("Array<")) {
            return this.sample(dataType);
        }
        if (modelVar.endsWith("Id") || modelVar === "id") {
            return this.uuidv4();
        }
        if (dataType === "boolean") {
            return this.nextBoolean();
        }
        if (dataType === "number") {
            return this.nextInt(100);
        }
        const key = `sample${dataType}` as keyof TestSampleData;
        if( typeof this[key] === "function"){
            return this[key]();
        }
        return "foo";
    }
    arrayLength(modelClass: string) {
        return this.nextInt(3) + 1;
    }
    sample(modelName: string): any {
        switch(modelName) {
            case "BrukerinfoAdresseDto": return this.sampleBrukerinfoAdresseDto({});
            case "Array<BrukerinfoAdresseDto>": return this.sampleArrayBrukerinfoAdresseDto({});
            case "BrukerinfoDto": return this.sampleBrukerinfoDto({});
            case "Array<BrukerinfoDto>": return this.sampleArrayBrukerinfoDto({});
            case "BrukerinnstillingerDto": return this.sampleBrukerinnstillingerDto({});
            case "Array<BrukerinnstillingerDto>": return this.sampleArrayBrukerinnstillingerDto({});
            case "EmneDto": return this.sampleEmneDto({});
            case "Array<EmneDto>": return this.sampleArrayEmneDto({});
            case "FagpersonDto": return this.sampleFagpersonDto({});
            case "Array<FagpersonDto>": return this.sampleArrayFagpersonDto({});
            case "MinimalPraksisstedDto": return this.sampleMinimalPraksisstedDto({});
            case "Array<MinimalPraksisstedDto>": return this.sampleArrayMinimalPraksisstedDto({});
            case "PraksisaktivitetDto": return this.samplePraksisaktivitetDto({});
            case "Array<PraksisaktivitetDto>": return this.sampleArrayPraksisaktivitetDto({});
            case "PraksisaktivitetStatuserDto": return this.samplePraksisaktivitetStatuserDto();
            case "Array<PraksisaktivitetStatuserDto>": return this.sampleArrayPraksisaktivitetStatuserDto();
            case "PraksisoversiktDto": return this.samplePraksisoversiktDto({});
            case "Array<PraksisoversiktDto>": return this.sampleArrayPraksisoversiktDto({});
            case "PraksisoversiktEmneDto": return this.samplePraksisoversiktEmneDto({});
            case "Array<PraksisoversiktEmneDto>": return this.sampleArrayPraksisoversiktEmneDto({});
            case "PraksisplassOnskeDto": return this.samplePraksisplassOnskeDto({});
            case "Array<PraksisplassOnskeDto>": return this.sampleArrayPraksisplassOnskeDto({});
            case "PraksisstedAvdelingDto": return this.samplePraksisstedAvdelingDto({});
            case "Array<PraksisstedAvdelingDto>": return this.sampleArrayPraksisstedAvdelingDto({});
            case "PraksisstedprofilAdresseDto": return this.samplePraksisstedprofilAdresseDto({});
            case "Array<PraksisstedprofilAdresseDto>": return this.sampleArrayPraksisstedprofilAdresseDto({});
            case "PraksisstedprofilDto": return this.samplePraksisstedprofilDto({});
            case "Array<PraksisstedprofilDto>": return this.sampleArrayPraksisstedprofilDto({});
            case "PraksisstedprofilNoderDto": return this.samplePraksisstedprofilNoderDto({});
            case "Array<PraksisstedprofilNoderDto>": return this.sampleArrayPraksisstedprofilNoderDto({});
            case "StudentDto": return this.sampleStudentDto({});
            case "Array<StudentDto>": return this.sampleArrayStudentDto({});
            default: throw new Error("Unknown type "+ modelName);
        }
    }
    sampleBrukerinfoAdresseDto(template?: Factory<BrukerinfoAdresseDto>): BrukerinfoAdresseDto {
        if (typeof this.sampleModelProperties["BrukerinfoAdresseDto"] === "function") {
            return this.sampleModelProperties["BrukerinfoAdresseDto"](this);
        }

        return {
            gateadresse: template && template.gateadresse ? (typeof template.gateadresse === "function" ? (template.gateadresse as Function)(this) : template.gateadresse): this.generate("BrukerinfoAdresseDto", "gateadresse", "string", "Lorem Ipsum gate 12", false),
            postnr: template && template.postnr ? (typeof template.postnr === "function" ? (template.postnr as Function)(this) : template.postnr): this.generate("BrukerinfoAdresseDto", "postnr", "string", "0440", false),
            poststed: template && template.poststed ? (typeof template.poststed === "function" ? (template.poststed as Function)(this) : template.poststed): this.generate("BrukerinfoAdresseDto", "poststed", "string", "Oslo", false),
        };
    }
    sampleArrayBrukerinfoAdresseDto(template?: Factory<BrukerinfoAdresseDto>, length?: number): Array<BrukerinfoAdresseDto> {
        return Array.from({length: length || this.arrayLength("BrukerinfoAdresseDto")}).map(() => this.sampleBrukerinfoAdresseDto(template));
    }
    sampleBrukerinfoDto(template?: Factory<BrukerinfoDto>): BrukerinfoDto {
        if (typeof this.sampleModelProperties["BrukerinfoDto"] === "function") {
            return this.sampleModelProperties["BrukerinfoDto"](this);
        }

        return {
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("BrukerinfoDto", "fornavn", "string", "Karl", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("BrukerinfoDto", "etternavn", "string", "Karlsen", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("BrukerinfoDto", "epost", "string", "mail@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("BrukerinfoDto", "telefonnummer", "string", "+47 000 00 000", false),
            studentnr: template && template.studentnr ? (typeof template.studentnr === "function" ? (template.studentnr as Function)(this) : template.studentnr): this.generate("BrukerinfoDto", "studentnr", "string", "S123456789", false),
            kjonn: template && template.kjonn ? (typeof template.kjonn === "function" ? (template.kjonn as Function)(this) : template.kjonn): this.pickOne([BrukerinfoDtoKjonnDtoEnum.Mann,BrukerinfoDtoKjonnDtoEnum.Kvinne]),
            alder: template && template.alder ? (typeof template.alder === "function" ? (template.alder as Function)(this) : template.alder): this.generate("BrukerinfoDto", "alder", "number", "19", false),
            adresse: template && template.adresse ? (typeof template.adresse === "function" ? (template.adresse as Function)(this) : template.adresse): this.generate("BrukerinfoDto", "adresse", "BrukerinfoAdresseDto", "null", false),
            innstillinger: template && template.innstillinger ? (typeof template.innstillinger === "function" ? (template.innstillinger as Function)(this) : template.innstillinger): this.generate("BrukerinfoDto", "innstillinger", "BrukerinnstillingerDto", "null", false),
        };
    }
    sampleArrayBrukerinfoDto(template?: Factory<BrukerinfoDto>, length?: number): Array<BrukerinfoDto> {
        return Array.from({length: length || this.arrayLength("BrukerinfoDto")}).map(() => this.sampleBrukerinfoDto(template));
    }
    sampleBrukerinnstillingerDto(template?: Factory<BrukerinnstillingerDto>): BrukerinnstillingerDto {
        if (typeof this.sampleModelProperties["BrukerinnstillingerDto"] === "function") {
            return this.sampleModelProperties["BrukerinnstillingerDto"](this);
        }

        return {
            spraakvalg: template && template.spraakvalg ? (typeof template.spraakvalg === "function" ? (template.spraakvalg as Function)(this) : template.spraakvalg): this.generate("BrukerinnstillingerDto", "spraakvalg", "string", "no", false),
            forstaatHvorProfildataKommerFra: template && template.forstaatHvorProfildataKommerFra ? (typeof template.forstaatHvorProfildataKommerFra === "function" ? (template.forstaatHvorProfildataKommerFra as Function)(this) : template.forstaatHvorProfildataKommerFra): this.generate("BrukerinnstillingerDto", "forstaatHvorProfildataKommerFra", "boolean", "null", false),
            harGodtattBetingelser: template && template.harGodtattBetingelser ? (typeof template.harGodtattBetingelser === "function" ? (template.harGodtattBetingelser as Function)(this) : template.harGodtattBetingelser): this.generate("BrukerinnstillingerDto", "harGodtattBetingelser", "boolean", "null", false),
        };
    }
    sampleArrayBrukerinnstillingerDto(template?: Factory<BrukerinnstillingerDto>, length?: number): Array<BrukerinnstillingerDto> {
        return Array.from({length: length || this.arrayLength("BrukerinnstillingerDto")}).map(() => this.sampleBrukerinnstillingerDto(template));
    }
    sampleEmneDto(template?: Factory<EmneDto>): EmneDto {
        if (typeof this.sampleModelProperties["EmneDto"] === "function") {
            return this.sampleModelProperties["EmneDto"](this);
        }

        return {
            kode: template && template.kode ? (typeof template.kode === "function" ? (template.kode as Function)(this) : template.kode): this.generate("EmneDto", "kode", "string", "SYBAPRA1", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("EmneDto", "navn", "string", "Praksisstudier i sykepleie", false),
        };
    }
    sampleArrayEmneDto(template?: Factory<EmneDto>, length?: number): Array<EmneDto> {
        return Array.from({length: length || this.arrayLength("EmneDto")}).map(() => this.sampleEmneDto(template));
    }
    sampleFagpersonDto(template?: Factory<FagpersonDto>): FagpersonDto {
        if (typeof this.sampleModelProperties["FagpersonDto"] === "function") {
            return this.sampleModelProperties["FagpersonDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("FagpersonDto", "id", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("FagpersonDto", "fornavn", "string", "Ola", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("FagpersonDto", "etternavn", "string", "Nordmann", false),
            rolle: template && template.rolle ? (typeof template.rolle === "function" ? (template.rolle as Function)(this) : template.rolle): this.pickOne([FagpersonDtoRolleDtoEnum.StudiestedKoordinator,FagpersonDtoRolleDtoEnum.StudiestedUnderviser,FagpersonDtoRolleDtoEnum.PraksisstedKoordinator,FagpersonDtoRolleDtoEnum.PraksisstedVeileder]),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("FagpersonDto", "epost", "string", "user@example.com", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("FagpersonDto", "telefonnummer", "string", "12345678", false),
        };
    }
    sampleArrayFagpersonDto(template?: Factory<FagpersonDto>, length?: number): Array<FagpersonDto> {
        return Array.from({length: length || this.arrayLength("FagpersonDto")}).map(() => this.sampleFagpersonDto(template));
    }
    sampleMinimalPraksisstedDto(template?: Factory<MinimalPraksisstedDto>): MinimalPraksisstedDto {
        if (typeof this.sampleModelProperties["MinimalPraksisstedDto"] === "function") {
            return this.sampleModelProperties["MinimalPraksisstedDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("MinimalPraksisstedDto", "id", "string", "0aaedfff-d134-447a-b8fc-39688210c29a", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("MinimalPraksisstedDto", "navn", "string", "Lovisenberg Diakonale Sykehus", false),
        };
    }
    sampleArrayMinimalPraksisstedDto(template?: Factory<MinimalPraksisstedDto>, length?: number): Array<MinimalPraksisstedDto> {
        return Array.from({length: length || this.arrayLength("MinimalPraksisstedDto")}).map(() => this.sampleMinimalPraksisstedDto(template));
    }
    samplePraksisaktivitetDto(template?: Factory<PraksisaktivitetDto>): PraksisaktivitetDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisaktivitetDto", "id", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            emne: template && template.emne ? (typeof template.emne === "function" ? (template.emne as Function)(this) : template.emne): this.generate("PraksisaktivitetDto", "emne", "EmneDto", "null", false),
            startDato: template && template.startDato ? (typeof template.startDato === "function" ? (template.startDato as Function)(this) : template.startDato): this.generate("PraksisaktivitetDto", "startDato", "string", "null", false),
            sluttDato: template && template.sluttDato ? (typeof template.sluttDato === "function" ? (template.sluttDato as Function)(this) : template.sluttDato): this.generate("PraksisaktivitetDto", "sluttDato", "string", "null", false),
            status: template && template.status ? (typeof template.status === "function" ? (template.status as Function)(this) : template.status): this.generate("PraksisaktivitetDto", "status", "PraksisaktivitetStatuserDto", "null", false),
            onskelisteFrist: template && template.onskelisteFrist ? (typeof template.onskelisteFrist === "function" ? (template.onskelisteFrist as Function)(this) : template.onskelisteFrist): this.generate("PraksisaktivitetDto", "onskelisteFrist", "string", "null", false),
            maxAntallOnsker: template && template.maxAntallOnsker ? (typeof template.maxAntallOnsker === "function" ? (template.maxAntallOnsker as Function)(this) : template.maxAntallOnsker): this.generate("PraksisaktivitetDto", "maxAntallOnsker", "number", "10", false),
            onskeliste: template && template.onskeliste ? (typeof template.onskeliste === "function" ? (template.onskeliste as Function)(this) : template.onskeliste): this.generate("PraksisaktivitetDto", "onskeliste", "Array<PraksisplassOnskeDto>", "null", false),
            praksisstedprofil: template && template.praksisstedprofil ? (typeof template.praksisstedprofil === "function" ? (template.praksisstedprofil as Function)(this) : template.praksisstedprofil): this.generate("PraksisaktivitetDto", "praksisstedprofil", "PraksisstedprofilDto", "null", false),
            fagpersoner: template && template.fagpersoner ? (typeof template.fagpersoner === "function" ? (template.fagpersoner as Function)(this) : template.fagpersoner): this.generate("PraksisaktivitetDto", "fagpersoner", "Array<FagpersonDto>", "null", false),
            medstudenter: template && template.medstudenter ? (typeof template.medstudenter === "function" ? (template.medstudenter as Function)(this) : template.medstudenter): this.generate("PraksisaktivitetDto", "medstudenter", "Array<StudentDto>", "null", false),
            fritekst: template && template.fritekst ? (typeof template.fritekst === "function" ? (template.fritekst as Function)(this) : template.fritekst): this.generate("PraksisaktivitetDto", "fritekst", "string", "Hei på deg, din gamle blei!", false),
        };
    }
    sampleArrayPraksisaktivitetDto(template?: Factory<PraksisaktivitetDto>, length?: number): Array<PraksisaktivitetDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetDto")}).map(() => this.samplePraksisaktivitetDto(template));
    }
    samplePraksisaktivitetStatuserDto(template?: EnumFactory<PraksisaktivitetStatuserDto>): PraksisaktivitetStatuserDto {
        if (typeof this.sampleModelProperties["PraksisaktivitetStatuserDto"] === "function") {
            return this.sampleModelProperties["PraksisaktivitetStatuserDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                PraksisaktivitetStatuserDto.Undervisningsmeldt,
                PraksisaktivitetStatuserDto.Registrert,
                PraksisaktivitetStatuserDto.OnskelisteTilgjengelig,
                PraksisaktivitetStatuserDto.OnskelisteRegistrert,
                PraksisaktivitetStatuserDto.OnskelisteRegistrertIkkeTilgjengelig,
                PraksisaktivitetStatuserDto.AvventerFordeling,
                PraksisaktivitetStatuserDto.IkkePublisert,
                PraksisaktivitetStatuserDto.PraksisplassMottatt,
                PraksisaktivitetStatuserDto.Aktiv,
                PraksisaktivitetStatuserDto.Gjennomfoert
        ]);
    }
    sampleArrayPraksisaktivitetStatuserDto(template?: EnumFactory<PraksisaktivitetStatuserDto>, length?: number): Array<PraksisaktivitetStatuserDto> {
        return Array.from({length: length || this.arrayLength("PraksisaktivitetStatuserDto")}).map(() => this.samplePraksisaktivitetStatuserDto());
    }
    samplePraksisoversiktDto(template?: Factory<PraksisoversiktDto>): PraksisoversiktDto {
        if (typeof this.sampleModelProperties["PraksisoversiktDto"] === "function") {
            return this.sampleModelProperties["PraksisoversiktDto"](this);
        }

        return {
            emner: template && template.emner ? (typeof template.emner === "function" ? (template.emner as Function)(this) : template.emner): this.generate("PraksisoversiktDto", "emner", "Array<PraksisoversiktEmneDto>", "null", false),
        };
    }
    sampleArrayPraksisoversiktDto(template?: Factory<PraksisoversiktDto>, length?: number): Array<PraksisoversiktDto> {
        return Array.from({length: length || this.arrayLength("PraksisoversiktDto")}).map(() => this.samplePraksisoversiktDto(template));
    }
    samplePraksisoversiktEmneDto(template?: Factory<PraksisoversiktEmneDto>): PraksisoversiktEmneDto {
        if (typeof this.sampleModelProperties["PraksisoversiktEmneDto"] === "function") {
            return this.sampleModelProperties["PraksisoversiktEmneDto"](this);
        }

        return {
            emne: template && template.emne ? (typeof template.emne === "function" ? (template.emne as Function)(this) : template.emne): this.generate("PraksisoversiktEmneDto", "emne", "string", "Grunnleggende sykepleie", false),
            status: template && template.status ? (typeof template.status === "function" ? (template.status as Function)(this) : template.status): this.generate("PraksisoversiktEmneDto", "status", "PraksisaktivitetStatuserDto", "null", false),
            startDato: template && template.startDato ? (typeof template.startDato === "function" ? (template.startDato as Function)(this) : template.startDato): this.generate("PraksisoversiktEmneDto", "startDato", "string", "Mon Oct 21 00:00:00 UTC 2019", false),
            sluttDato: template && template.sluttDato ? (typeof template.sluttDato === "function" ? (template.sluttDato as Function)(this) : template.sluttDato): this.generate("PraksisoversiktEmneDto", "sluttDato", "string", "Wed Oct 30 00:00:00 UTC 2019", false),
            praksissaktivitet: template && template.praksissaktivitet ? (typeof template.praksissaktivitet === "function" ? (template.praksissaktivitet as Function)(this) : template.praksissaktivitet): this.generate("PraksisoversiktEmneDto", "praksissaktivitet", "string", "null", false),
        };
    }
    sampleArrayPraksisoversiktEmneDto(template?: Factory<PraksisoversiktEmneDto>, length?: number): Array<PraksisoversiktEmneDto> {
        return Array.from({length: length || this.arrayLength("PraksisoversiktEmneDto")}).map(() => this.samplePraksisoversiktEmneDto(template));
    }
    samplePraksisplassOnskeDto(template?: Factory<PraksisplassOnskeDto>): PraksisplassOnskeDto {
        if (typeof this.sampleModelProperties["PraksisplassOnskeDto"] === "function") {
            return this.sampleModelProperties["PraksisplassOnskeDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisplassOnskeDto", "id", "string", "0aaedfff-d134-447a-b8fc-39688210c29a", false),
            praksissted: template && template.praksissted ? (typeof template.praksissted === "function" ? (template.praksissted as Function)(this) : template.praksissted): this.generate("PraksisplassOnskeDto", "praksissted", "MinimalPraksisstedDto", "null", false),
            praksisplass: template && template.praksisplass ? (typeof template.praksisplass === "function" ? (template.praksisplass as Function)(this) : template.praksisplass): this.generate("PraksisplassOnskeDto", "praksisplass", "MinimalPraksisstedDto", "null", false),
        };
    }
    sampleArrayPraksisplassOnskeDto(template?: Factory<PraksisplassOnskeDto>, length?: number): Array<PraksisplassOnskeDto> {
        return Array.from({length: length || this.arrayLength("PraksisplassOnskeDto")}).map(() => this.samplePraksisplassOnskeDto(template));
    }
    samplePraksisstedAvdelingDto(template?: Factory<PraksisstedAvdelingDto>): PraksisstedAvdelingDto {
        if (typeof this.sampleModelProperties["PraksisstedAvdelingDto"] === "function") {
            return this.sampleModelProperties["PraksisstedAvdelingDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisstedAvdelingDto", "id", "string", "0aaedfff-d134-447a-b8fc-39688210c29a", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksisstedAvdelingDto", "navn", "string", "Lovisenberg Diakonale Sykehus", false),
            bildeUrler: template && template.bildeUrler ? (typeof template.bildeUrler === "function" ? (template.bildeUrler as Function)(this) : template.bildeUrler): this.generate("PraksisstedAvdelingDto", "bildeUrler", "Array<string>", "null", false),
            beskrivelse: template && template.beskrivelse ? (typeof template.beskrivelse === "function" ? (template.beskrivelse as Function)(this) : template.beskrivelse): this.generate("PraksisstedAvdelingDto", "beskrivelse", "string", "Lorem ipsum", false),
            praksisstedTopp: template && template.praksisstedTopp ? (typeof template.praksisstedTopp === "function" ? (template.praksisstedTopp as Function)(this) : template.praksisstedTopp): this.generate("PraksisstedAvdelingDto", "praksisstedTopp", "MinimalPraksisstedDto", "null", false),
        };
    }
    sampleArrayPraksisstedAvdelingDto(template?: Factory<PraksisstedAvdelingDto>, length?: number): Array<PraksisstedAvdelingDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedAvdelingDto")}).map(() => this.samplePraksisstedAvdelingDto(template));
    }
    samplePraksisstedprofilAdresseDto(template?: Factory<PraksisstedprofilAdresseDto>): PraksisstedprofilAdresseDto {
        if (typeof this.sampleModelProperties["PraksisstedprofilAdresseDto"] === "function") {
            return this.sampleModelProperties["PraksisstedprofilAdresseDto"](this);
        }

        return {
            adresselinje1: template && template.adresselinje1 ? (typeof template.adresselinje1 === "function" ? (template.adresselinje1 as Function)(this) : template.adresselinje1): this.generate("PraksisstedprofilAdresseDto", "adresselinje1", "string", "Lorem Ipsum gate 12", false),
            adresselinje2: template && template.adresselinje2 ? (typeof template.adresselinje2 === "function" ? (template.adresselinje2 as Function)(this) : template.adresselinje2): this.generate("PraksisstedprofilAdresseDto", "adresselinje2", "string", "1. etasje", false),
            postnr: template && template.postnr ? (typeof template.postnr === "function" ? (template.postnr as Function)(this) : template.postnr): this.generate("PraksisstedprofilAdresseDto", "postnr", "string", "0440", false),
            poststed: template && template.poststed ? (typeof template.poststed === "function" ? (template.poststed as Function)(this) : template.poststed): this.generate("PraksisstedprofilAdresseDto", "poststed", "string", "Oslo", false),
        };
    }
    sampleArrayPraksisstedprofilAdresseDto(template?: Factory<PraksisstedprofilAdresseDto>, length?: number): Array<PraksisstedprofilAdresseDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedprofilAdresseDto")}).map(() => this.samplePraksisstedprofilAdresseDto(template));
    }
    samplePraksisstedprofilDto(template?: Factory<PraksisstedprofilDto>): PraksisstedprofilDto {
        if (typeof this.sampleModelProperties["PraksisstedprofilDto"] === "function") {
            return this.sampleModelProperties["PraksisstedprofilDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisstedprofilDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksisstedprofilDto", "navn", "string", "Lovisenberg Diakonale Sykehus", false),
            orgnr: template && template.orgnr ? (typeof template.orgnr === "function" ? (template.orgnr as Function)(this) : template.orgnr): this.generate("PraksisstedprofilDto", "orgnr", "string", "123423413412", false),
            avdeling: template && template.avdeling ? (typeof template.avdeling === "function" ? (template.avdeling as Function)(this) : template.avdeling): this.generate("PraksisstedprofilDto", "avdeling", "MinimalPraksisstedDto", "null", false),
            adresse: template && template.adresse ? (typeof template.adresse === "function" ? (template.adresse as Function)(this) : template.adresse): this.generate("PraksisstedprofilDto", "adresse", "PraksisstedprofilAdresseDto", "null", false),
            nettsideUrl: template && template.nettsideUrl ? (typeof template.nettsideUrl === "function" ? (template.nettsideUrl as Function)(this) : template.nettsideUrl): this.generate("PraksisstedprofilDto", "nettsideUrl", "string", "https://lovisenbergdiakonale.no", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("PraksisstedprofilDto", "epost", "string", "resepsjon@lovisenbergdiakonale.no", false),
            telefonnummer: template && template.telefonnummer ? (typeof template.telefonnummer === "function" ? (template.telefonnummer as Function)(this) : template.telefonnummer): this.generate("PraksisstedprofilDto", "telefonnummer", "string", "12345678", false),
            bildeUrl: template && template.bildeUrl ? (typeof template.bildeUrl === "function" ? (template.bildeUrl as Function)(this) : template.bildeUrl): this.generate("PraksisstedprofilDto", "bildeUrl", "string", "bilde.png", false),
            beskrivelse: template && template.beskrivelse ? (typeof template.beskrivelse === "function" ? (template.beskrivelse as Function)(this) : template.beskrivelse): this.generate("PraksisstedprofilDto", "beskrivelse", "string", "Lorem Ipsum", false),
            krav: template && template.krav ? (typeof template.krav === "function" ? (template.krav as Function)(this) : template.krav): this.generate("PraksisstedprofilDto", "krav", "string", "Personlig egnethet", false),
            noder: template && template.noder ? (typeof template.noder === "function" ? (template.noder as Function)(this) : template.noder): this.generate("PraksisstedprofilDto", "noder", "PraksisstedprofilNoderDto", "null", false),
        };
    }
    sampleArrayPraksisstedprofilDto(template?: Factory<PraksisstedprofilDto>, length?: number): Array<PraksisstedprofilDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedprofilDto")}).map(() => this.samplePraksisstedprofilDto(template));
    }
    samplePraksisstedprofilNoderDto(template?: Factory<PraksisstedprofilNoderDto>): PraksisstedprofilNoderDto {
        if (typeof this.sampleModelProperties["PraksisstedprofilNoderDto"] === "function") {
            return this.sampleModelProperties["PraksisstedprofilNoderDto"](this);
        }

        return {
            over: template && template.over ? (typeof template.over === "function" ? (template.over as Function)(this) : template.over): this.generate("PraksisstedprofilNoderDto", "over", "Array<MinimalPraksisstedDto>", "null", false),
        };
    }
    sampleArrayPraksisstedprofilNoderDto(template?: Factory<PraksisstedprofilNoderDto>, length?: number): Array<PraksisstedprofilNoderDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedprofilNoderDto")}).map(() => this.samplePraksisstedprofilNoderDto(template));
    }
    sampleStudentDto(template?: Factory<StudentDto>): StudentDto {
        if (typeof this.sampleModelProperties["StudentDto"] === "function") {
            return this.sampleModelProperties["StudentDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("StudentDto", "id", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("StudentDto", "fornavn", "string", "Ola", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("StudentDto", "etternavn", "string", "Nordmann", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("StudentDto", "epost", "string", "user@example.com", false),
        };
    }
    sampleArrayStudentDto(template?: Factory<StudentDto>, length?: number): Array<StudentDto> {
        return Array.from({length: length || this.arrayLength("StudentDto")}).map(() => this.sampleStudentDto(template));
    }
}
